import { render, staticRenderFns } from "./sfQrCode.vue?vue&type=template&id=30a32978&scoped=true"
import script from "./sfQrCode.vue?vue&type=script&lang=js"
export * from "./sfQrCode.vue?vue&type=script&lang=js"
import style0 from "./sfQrCode.vue?vue&type=style&index=0&id=30a32978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a32978",
  null
  
)

export default component.exports